







import {
  defineComponent,
  useFetch,
  ref,
} from '@nuxtjs/composition-api';
// eslint-disable-next-line
import ClientOnly from 'vue-client-only';
import { usePageResolver } from '~/stores/page';
import Notification from '~/components/Notification.vue';
import CATEGORY from '~/modules/catalog/pages/category.vue';
import CMS_PAGE from '~/pages/Cms.vue';
import PRODUCT from '~/pages/Product/_slug/index.vue';
import HOT_TOPICS from '~/pages/solepro/HotTopicsPage.vue';
import HOT_TOPIC from '~/pages/solepro/HotTopicPage.vue';
import NOT_FOUND  from '~/pages/solepro/Error.vue';

export default defineComponent({
  name: 'PageResolver',
  components: {
    Notification,
    CATEGORY,
    CMS_PAGE,
    PRODUCT,
    HOT_TOPICS,
    HOT_TOPIC,
    NOT_FOUND,
    ClientOnly,
  },
  props:{
    categoryName: {
      type: String,
    },
    preselectedSort: {
      type: String,
      required: false
    }
  },
  setup(props) {
    const pageData = ref(null);
    const customProps = ref(null);
    const { resolveUrl } = usePageResolver();
    useFetch(async () => {
      const pageDatas = await resolveUrl();
      customProps.value = {
        ...(pageDatas.customProps ? {...pageDatas.customProps} : {}),
        ...(props ? {...props} : {}),
      };
      pageData.value = pageDatas;
    });
    return {
      pageData,
      customProps
    };
  },
});
